export enum Duration
 {
  years = 'years',
  months = 'months',
  weeks = 'weeks',
  days = 'days',
}
